// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"f1-z","subtitle":"g1-z","wrapper":"h1-z","leftArrow":"i1-z","rightArrow":"j1-z"};